/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React, { useState } from "react";
import FormFader from "../Common/Fader/FormFader";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import FormSubmit from "../Common/FormSubmit/FormSubmit";
import CheckIcon from "../../../assets/icons/common/toggleable/IconCheck";
import CrossIcon from "../../../assets/icons/common/toggleable/IconClose";
import QuestionIcon from "../../../assets/icons/common/toggleable/IconQuestionmark";
import { useForm } from "../../../provider/Form/FormProvider";
import Group from "../../Wizard/Group";
import { requiredValidator } from "../../../services/validationRules";
import Typography from "@mui/material/Typography";
import { translate } from "../../../services/translations/translations";
import FormSubmitProps from "../../../types/FormSubmitProps";
import { FormDataTypes } from "../../../types/FormDataTypes";
import { Box, Button } from "@mui/material";
import MoreInfoIcon from "../../SvgIcon/MoreInfoIcon";
import DialogModal from "../../DialogModal/DialogModal";
import wizardStyle from "../wizardStyle";

export default function Flashed({ submitProps }: { submitProps: FormSubmitProps }) {
  const { handleSubmit, values }: FormDataTypes = useForm();
  const [infoModalOpen, setInfoModalOpen] = useState(false);
  return (
    <Paper sx={wizardStyle.paper} elevation={4}>
      <FormFader>
        <Box component={"form"} sx={{ ...wizardStyle.applicationForm, ...wizardStyle.wizardForm }} onSubmit={handleSubmit}>
          <Typography variant={"h4"} sx={[wizardStyle.headline, { display: { xs: "block", sm: "none" } }]}>
            Zum Fahrer
          </Typography>
          <Grid
            container
            sx={{
              justifyContent: "center",
            }}
          >
            <Grid size={12}>
              <Group
                type="radio"
                name="flashed"
                question={
                  <>
                    {translate("traffic.flashed.label", values)}
                    {values.accusation !== "speeding" && (
                      <Button fullWidth={true} variant={"text"} color={"primary"} onClick={() => setInfoModalOpen(true)}>
                        <MoreInfoIcon sx={wizardStyle.leftIcon} />
                        Warum wird dies abgefragt?
                      </Button>
                    )}
                  </>
                }
                options={[
                  {
                    labelText: translate("traffic.flashed.options.yes.label", values),
                    labelIcon: <CheckIcon />,
                    labelIconActive: <CheckIcon active />,
                    value: "yes",
                  },
                  {
                    labelText: translate("traffic.flashed.options.no.label", values),
                    labelIcon: <CrossIcon />,
                    labelIconActive: <CrossIcon active />,
                    value: "no",
                  },
                  {
                    labelText: translate("traffic.flashed.options.unknown.label", values),
                    labelIcon: <QuestionIcon />,
                    labelIconActive: <QuestionIcon active />,
                    value: "unknown",
                  },
                ]}
                validators={[requiredValidator("Bitte wählen Sie eine der angezeigten Antworten aus")]}
              />
            </Grid>
          </Grid>
          <FormSubmit {...submitProps} />
        </Box>
      </FormFader>
      <DialogModal open={infoModalOpen} onClose={() => setInfoModalOpen(false)} title={"Weitere Informationen"}>
        <p>
          Obwohl es sich bei der von Ihnen gemeldeten Ordnungswidrigkeit nicht um einen Geschwindigkeitsverstoß handelt, ist es für die weitere Strategie und
          die Erfolgsaussichten Ihres Rechtsfalls gegebenenfalls relevant, ob Sie innerhalb der letzten 12 Monate bereits einen Bußgeldbescheid wegen überhöhter
          Geschwindigkeit erhalten haben.
        </p>
      </DialogModal>
    </Paper>
  );
}
